<template>
    <div class="box">
      <header class="header">
        <img class="img" src="@/static/image/back.png" @click="back" />
        <div class="header_title">订单详情</div>
      </header>
      <div class="bill">
        <div class="bill_info">
          <div class="bill_info_head">
            <span class="bill_info_head_text">单据编号： {{ bill.number }}</span>
          </div>
          <div class="line"></div>
          <div class="bill_info_item" style="padding-top: 0.32rem">
            <span class="bill_info_item_text">收款金额： </span>
            <span class="bill_info_item_context">￥{{ bill.sum }}</span>
          </div>
          <div class="bill_info_item">
            <span class="bill_info_item_text">制单时间： </span>
            <span class="bill_info_item_context">￥{{ bill.dateTime }}</span>
          </div>
        </div>
        <div class="bill_detail">
          <div class="bill_detail_head">
            <span class="bill_detail_head_text">{{ bill.balanceMethod === 0 ? '单据明细' : '商品明细' }}</span>
            <span v-if="bill.balanceMethod === 0" class="bill_detail_head_context">
              共 {{ bill.billBalanceDetails ? bill.billBalanceDetails.length : 0 }} 单
            </span>
            <span v-else class="bill_detail_head_context">
              共 {{ bill.goodsBalanceDetails ? bill.goodsBalanceDetails.length : 0 }} 种
            </span>
          </div>
          <div class="line" style="position: relative;top: 1.31rem;"></div>
          <div class="balance" v-if="bill.balanceMethod === 0">
            <div class="bill_balance_detail" v-for="(item, index) in bill.billBalanceDetails" :key="index">
              <div class="balance_bill">
                <span style="font-size: 0.37rem;font-family: PingFang SC;font-weight: 500;color: #333333;">{{ item.billNumber }}</span>
                <span style="font-size: 0.32rem;font-family: PingFang SC;font-weight: 500;color: #666666;"> 金额： ￥{{ item.billSum }}</span>
              </div>
              <div class="balance_info">
                <span style="font-size: 0.32rem;font-family: PingFang SC;font-weight: 500;color: #666666;">结算金额： ￥{{ item.balanceSum }}</span>
                <van-button size="small" color="#FFFFFF" icon-colir="#666666" type="primary" @click="toBill(item.billId, item.billType)">
                  <van-icon name="arrow" color="#666666" size="0.46rem"/>
                </van-button>
              </div>
            </div>
            <div class="line"></div>
          </div>
          <div class="balance" v-else>
            <div class="goods_balance_detail" v-for="(item, index) in bill.goodsBalanceDetails" :key="index">
              <img class="goods_img" :src="item.goodsPicUrl ? item.goodsPicUrl : require('@/static/image/defaultImage.png')"/>
              <div class="goods_info">
                <span style="height: 0.37rem;line-height: 0.37rem;padding-top: 0.25rem;font-size: 0.37rem;font-family: PingFang SC;font-weight: 500;color: #333333;">
                  {{ item.goodsName }}
                </span>
                <span style="height: 0.32rem;line-height: 0.32rem;padding-top: 0.35rem;font-size: 0.32rem;font-family: PingFang SC;font-weight: 500;color: #666666;">
                  {{ item.goodsStandard }}
                </span>
                <span style="height: 0.32rem;line-height: 0.32rem;padding-top: 0.35rem;font-size: 0.32rem;font-family: PingFang SC;font-weight: 500;color: #333333;">
                  单价： ￥{{ item.goodsPrice }}
                </span>
                <div class="goods_balance">
                  <span style="font-size: 0.32rem;font-family: PingFang SC;font-weight: 500;color: #333333;">
                    结算数量： {{ item.balanceQuantity }}
                  </span>
                  <span style="height: 0.48rem;line-height: 0.48rem;font-size: 0.32rem;font-family: PingFang SC;font-weight: 500;">
                    <span style="color: #333333;">
                      结算金额：
                    </span>
                    <span style="color: #FF553E;">
                      ￥
                      <span style="font-size: 0.48rem;">{{ item.balanceSum }}</span>
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="loadding_box" v-show="loading">
        <div class="loadding">
          <img class="logo" src="../static/image/logo.png" alt="" />加载中...
        </div>
      </div>
    </div>

</template>

<script>
import { getReceiptBill } from "../api/orderdetial.js";
import { headers } from "@/api/orderdetial.js";
import wxAuth from "../module/wx-auth";

export default {
  data() {
    return {
      billId: 0,
      billType: 0,
      userInfo: {},
      loading: true,
      bill: {}
    };
  },

  methods: {
    toBill(billId, billType) {
      this.$router.push({
        name: "SaleBillDetial",
        query: {
          customerId: this.encodeCustomerId,
          billId: billId,
          billType: billType,
        },
      });
    },
    // 返回
    back() {
      let previousRoute = this.$store.getters.getPreviousRoute();
      if(previousRoute) {
        this.$router.back();
      }else {
        let noDecodeCustomerId = wxAuth.getEncodeCustomerId();
        this.$router.push({
          name: "User",
          query: {
            customerId: noDecodeCustomerId
          }
        });
      }     
    },
    // 获取单据详情
    getBill() {
      let billId = this.billId
      let billType = this.billType;
      let param = {
        billId: billId,
        billType: billType,
      };
      getReceiptBill(param).then((res) => {
        this.loading = false;
        this.bill = res.data;
      });
    }
  },

  async created() {
    let query = this.$route.query;
    let billId = query.billId;
    this.billId = billId;
    let billType = query.billType;
    this.billType = billType;

    await wxAuth.auth();
    let noDecodeCustomerId = wxAuth.getEncodeCustomerId();
    headers.customerId = wxAuth.getDecodeCustomerId();
    let customerIdParam = encodeURIComponent(noDecodeCustomerId);
    window.history.replaceState(
      {},
      "",
      `./#/receiptBillDetail?customerId=${customerIdParam}&billId=${billId}&billType=${billType}`
    );
    this.userInfo = wxAuth.getUserInfo();
    this.getBill();
  },
};
</script>

<style lang='scss' scoped>

.balance_info {
  display: flex;
  align-items: center;
}

.balance_bill {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.bill_balance_detail {
  height: 1.19rem;
  display: flex;
  justify-content: space-between;
  padding: 0.31rem 0.32rem 0.25rem 0.32rem;
  padding-top: 0.32rem;
  padding-left: 0.32rem;
}

.goods_balance {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding-top: 0.2rem;
}

.goods_info {
  width: calc(100% - 2.8rem - 0.27rem - 0.31rem);
  display: flex;
  flex-direction: column;
  padding-right: 0.31rem;
}

.goods_img {
  width: 2.8rem;
  height: 2.8rem;
  border-radius: 0.27rem;
}

.goods_balance_detail {
  display: flex;
  justify-content: space-between;
  padding-top: 0.27rem;
  padding-left: 0.32rem;
  // align-items: center;
}

.balance {
  height: calc(100% - 1.31rem);
  position: relative;
  overflow: auto;
  top: 1.31rem;
}

.bill_detail_head_context {
  font-size: 0.37rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #777777;
  line-height: 1.31rem;
}

.bill_detail_head_text {
  font-size: 0.37rem;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 1.31rem;
}

.bill_detail_head {
  width: 8.64rem;
  height: 1.31rem;
  padding-left: 0.32rem;
  padding-right: 0.24rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
}

.bill_detail {
  width: 9.2rem;
  height: calc(100% - 2.92rem - 0.27rem * 2);
  margin: 0.27rem 0;
  background: #FFFFFF;
  box-shadow: 0.03rem 0.03rem 0.03rem 0.01rem #EBEBEB;
  border-radius: 0.27rem;
}

.bill_info_item_context {
  font-size: 0.32rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 0.31rem;
}

.bill_info_item_text {
  font-size: 0.32rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
}

.bill_info_item {
  height: 0.32rem;
  line-height: 0.32rem;
  padding-top: 0.25rem;
  padding-left: 0.32rem;
}

.bill_info_head_text {
  font-size: 0.37rem;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 1.31rem;
}

.bill_info_head {
  height: 1.31rem;
  padding-left: 0.32rem;
}

.bill_info{
  width: 9.2rem;
  height: 2.92rem;
  background: #FFFFFF;
  box-shadow: 0.03rem 0.03rem 0.03rem 0.01rem #EBEBEB;
  border-radius: 0.27rem;
}

.line {
  width: 8.56rem;
  height: 0.01rem;
  background: #F0F0F0;
  margin: 0 auto;
}

.bill {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 1.44rem);
  position: relative;
  top: 1.44rem;
}

 /* 公共的 =============== */
.logo {
  width: 1.8rem;
}

.loadding {
  width: 4rem;
  height: 3rem;
  padding: 0.3rem;
  background: #696767;
  color: #fff;
  border-radius: 0.206667rem;
  font-size: 0.5rem;
  text-align: center;
}

.loadding_box {
  width: 100vw;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  /* background: rgba(0, 0, 0, .2); */
  display: flex;
  justify-content: center;
  align-items: center;
}

.header_title{
   font-size: 0.48rem;
    font-weight: bold;
    color: #FFFFFF;
}

.img{
    height: 0.55rem;
    position: absolute;
    left: 0.4rem;
}

.header{
    width: 100vw;
    height: 1.173333rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #495CE1;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
}

.box{
    width: 100vw;
    min-height: 100vh;
    height: 100vh;
    overflow: visible;
    background-color: #f5f5f5;
}
</style>
